import { useNavigate } from "react-router-dom";
const useCustomNavigate = () => {
    const navigate = useNavigate();

    const navigateTo = (route: any) => {
        navigate(route || '/')
    }
return navigateTo;
}
export default useCustomNavigate;